import { IconButton, ButtonBase } from '@mui/material';
import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import styles from './RemoveUserModal.module.scss';

const RemoveUserModal = ({ open, handleClose, userFullName, deleteUser }) => (
  <Modal
    open={open}
    BackdropProps={{
      style: {
        backgroundColor: 'white',
        backdropFilter: 'blur(14px)',
        background: 'rgba(250, 250, 250, 0.8)',
      },
    }}
    onClose={handleClose}
    aria-labelledby="parent-modal-title"
    aria-describedby="parent-modal-description"
  >
    <Box className={styles.removeUserModal}>
      <Box className={styles.modalTitle}>
        Do you really want to remove {userFullName} from TransparenTerra?
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 30,
            top: 20,
            color: (theme) => theme.palette.grey[900],
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className={styles.modalActions}>
        <ButtonBase className={styles.leftButton} onClick={handleClose}>
          CANCEL
        </ButtonBase>
        <ButtonBase
          className={styles.rightButton}
          onClick={() => {
            deleteUser();
            handleClose();
          }}
        >
          YES
        </ButtonBase>
      </Box>
    </Box>
  </Modal>
);

export default RemoveUserModal;
